<template>
	<div class="presentations">
		<div class="head">
			<!--<md-button class="md-raised">Időpontváltozás jelzése</md-button>-->
			<md-button class="md-raised" v-on:click.native="create(true)">Új szekció</md-button>
			<md-button class="md-raised" v-on:click.native="create(false)">Új előadás</md-button>
		</div>
		
		<div v-if="rootPresentations.length == 0" class="card">
			... Betöltés ...
		</div>

		<div v-for="presentation in rootPresentations">
			<presentation-row :presentation="presentation" :depth="0"></presentation-row>
		</div>

	</div>
</template>

<script>
	import Vue from 'vue'
	import FirebaseDBService from '../../services/FirebaseDBService'
	import moment from 'moment'
	import _ from 'lodash'

	const colors = [
	"#00a8ff",
	"#4cd137",
	"#487eb0",
	"#e84118",
	"#9c88ff",
	"#273c75",
	"#fbc531"
	];

	export default {
		components: {
			'presentation-row': require('./PresentationRow')
		},
		data () {
			return {
				presentations: [],
				rootPresentations: [],
				sectionCollapsed: [],
				sectionColor: {},
				ratings: {},
				comments: {},
				date: moment().format("MMMM Do YYYY")
			}
		},
		methods: {
			loadData: function(){
				// Little callback hell, will be refactored of course
				FirebaseDBService.rawGet("comments", (err, comments) => {
					this.comments = comments;
					
					FirebaseDBService.rawGet("ratings", (err, ratings) => {
						this.ratings = ratings;

						FirebaseDBService.getPresentations((err, presentations) => {
							this.presentations = _.orderBy(presentations, "fromDate");

							// Check which presentation is a section (this is a migration fix, will be removed later)
							const sectionIds = _.chain(this.presentations).map("section").filter(_.isString).uniq().value();
							this.presentations = _.map(this.presentations, p => {
								if(p.isSection === undefined){
									p.isSection = _.includes(sectionIds, p.fireId);	
								}
								return p;
							});

							// Add comments and ratings to the presentations
							console.log("ratings", ratings);
							console.log("comments", comments);

							for(var presentation of this.presentations){
								presentation.ratingCount = 0;
								presentation.ratingAvg = 0;
								presentation.ratings = {};
								presentation.comments = {};
							}

							for(var userId in comments){
								for(var presentationId in comments[userId]){
									var presentation = _.find(this.presentations, {"fireId": presentationId});
									if(presentation){
										if(comments[userId][presentationId].length > 1){
											presentation.comments[userId] = comments[userId][presentationId];
										}
									}
								}
							}
				
							for(var userId in ratings){
								for(var presentationId in ratings[userId]){
									var presentation = _.find(presentations, {"fireId": presentationId});
									if(presentation){
										presentation.ratingCount += 1;
										presentation.ratingAvg += ratings[userId][presentationId];
										presentation.ratings[userId] = ratings[userId][presentationId];
									}
								}
							}

														console.log("this.presentations", JSON.stringify(this.presentations));


							for(var presentation of presentations){
								if(presentation.ratingCount > 0){
									presentation.ratingAvg = (presentation.ratingAvg / presentation.ratingCount).toFixed(2);
								}
							}

							// Transform presentations into a tree (with sections)
							var sectionIndex = 0;
							for(var presentation of presentations){
								presentation.key = presentation.fireId;
								var section = _.findLast(presentations, {fireId: presentation.section});
								if(section){
									if(!section.presentations){
							          // New section found
							          this.sectionCollapsed[section.fireId] = true;
							          this.sectionColor[section.fireId] = colors[sectionIndex % colors.length];
							          section.presentations = [];
							          sectionIndex++;
							      }
							      section.presentations.push(presentation);
							  }else{
							  	this.rootPresentations.push(presentation);
							  }
							}

							

							// This script logs all presentations after 2018 where we have comments or ratings
							/*
							let interestingPres = _.filter(presentations, function(o){
								return new Date(o.fromDate) > new Date("2018-01-01") && (o.ratingCount > 0 || Object.keys(o.comments).length > 0);
							});
							var exp = "";
							for(var pres of interestingPres){
								var comm = "";
								for(var key in pres.comments){
									comm += pres.comments[key].replace(/(\r\n\t|\n|\r\t)/gm,"") + ";;";
								}
								exp += pres.title + ";;" + pres.ratingCount + ";;" + pres.ratingAvg + ";;" + comm + "\n";
							}
							console.log(exp);
							*/
						});
					});
				});	
			},
			goToRoute: function(name){
				this.$router.replace({name: name});
			},
			create(isSection){
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', isSection: isSection }});
			},
			countRatings: function (presentation) {
				var count = 0;
				for(let key in presentation.ratings){
					count += presentation.ratings[key];
				}
				return count;
			},
			sumRatings: function (presentation) {
				var sum = 0;
				for(let key in presentation.ratings){
					sum += key * presentation.ratings[key];
				}
				return sum;
			}
		},
		mounted(){
			this.loadData();
		}
	}
</script>

<style scoped>
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #F0AA57;
	}

	.details{
		font-size: 12pt;
	}

	.isSection{
		background-color: rgb(157, 230, 255);
	}
</style>



// WEBPACK FOOTER //
// PresentationsView.vue?484bc3cb